"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverifyEmail = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var ReverifyEmailAction_1 = require("@/pages/reverifyEmail/actions/ReverifyEmailAction");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var ForgotPasswordFormComponent_1 = require("@/pages/forgotPassword/components/ForgotPasswordFormComponent");
var mapStateToProps = function (state) {
    return state.reverifyEmail;
};
var mapDispatchToProps = function (dispatch) { return ({
    onReverifyEmailFormSubmit: function (fields) {
        return dispatch(ReverifyEmailAction_1.default.onReverifyEmailFormSubmit(fields));
    },
}); };
exports.reverifyEmail = function (props) {
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { id: "reverify-page", className: "g-reset l-container l-container--r75 l-container--stackable l-pad-top--3" },
            React.createElement("div", { className: "l-container__main" },
                React.createElement("div", { className: "c-page-header c-page-header--center" },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("div", { className: "c-page-header__title" }, props.t.nameReverifyEmailTitle),
                        React.createElement("div", { className: "c-page-header__caption" }, props.t.nameReverifyEmailCaption))),
                React.createElement(ForgotPasswordFormComponent_1.default, { form: props.form, tForm: props.tForm, ui: { isLoading: props.isLoading }, errors: props.errors, onFormSubmit: props.onReverifyEmailFormSubmit })),
            React.createElement("div", { className: "l-container__side c-side c-side--for-items" },
                React.createElement("div", { className: "c-side__item" },
                    React.createElement("div", { className: "c-side__body c-side__body--padleft" },
                        React.createElement("div", { className: "c-side__title" }, props.t.needSupportTitle),
                        React.createElement("div", { className: "c-side__caption" },
                            React.createElement("div", { className: "c-labelrow" },
                                React.createElement("div", { className: "c-labelrow__label" },
                                    React.createElement("i", { className: "fa fa-envelope" })),
                                React.createElement("div", { className: "c-labelrow__value" },
                                    React.createElement("a", { href: "mailto:" + props.t.needSupportEmail },
                                        " ",
                                        props.t.needSupportEmail,
                                        " "))),
                            React.createElement("div", { className: "c-labelrow" },
                                React.createElement("div", { className: "c-labelrow__label" },
                                    React.createElement("i", { className: "fa fa-phone" })),
                                React.createElement("div", { className: "c-labelrow__value" }, props.t.needSupportPhone)))))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.reverifyEmail);
